exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-wrap[data-v-f94536c2]{max-height:calc(100% - 40px)}", ""]);

// exports
